import { render, staticRenderFns } from "./sync-call-mapper.vue?vue&type=template&id=4d87c4f6&scoped=true"
import script from "./sync-call-mapper.vue?vue&type=script&lang=js"
export * from "./sync-call-mapper.vue?vue&type=script&lang=js"
import style0 from "./sync-call-mapper.vue?vue&type=style&index=0&id=4d87c4f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d87c4f6",
  null
  
)

export default component.exports